// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'
import { ActivityPhaseSchema } from '../inputTypeSchemas/ActivityPhaseSchema'
import { ActivityTypeSchema } from '../inputTypeSchemas/ActivityTypeSchema'
import { ActivityOperatorSchema } from '../inputTypeSchemas/ActivityOperatorSchema'

/////////////////////////////////////////
// ACTIVITY RUN SCHEMA
/////////////////////////////////////////

/**
 * Execution context for an automated or manual unit of work performed in a phase.
 * `targetId` is polymorphic over NetBlock | Domain | Host | NetworkService | Software within the
 * EXTERNAL_NETWORK module — caller knows the entity kind from query context (e.g. the Host page
 * queries by hostId). For isolated render, store entity kind in `metadata`.
 */
export const ActivityRunSchema = z.object({
  phase: ActivityPhaseSchema,
  activityType: ActivityTypeSchema,
  operator: ActivityOperatorSchema,
  id: z.string(),
  tenantId: z.string().nullable(),
  scanId: z.string().nullable(),
  targetId: z.string(),
  summary: z.string(),
  traceId: z.string().nullable(),
  startedAt: z.coerce.date(),
  completedAt: z.coerce.date().nullable(),
  metadata: JsonValueSchema.nullable(),
})

export type ActivityRun = z.infer<typeof ActivityRunSchema>

export default ActivityRunSchema;
